import React from 'react';
import styled from 'styled-components';
import {FormattedMessage} from 'react-intl';
import InputSelectFieldWithValidation from '../../../../../common/InputSelectFieldWithValidation';
import {TextareaFieldWithValidation} from '../../../../../common/TextareaFieldWithValidation';
import {
    FORM_FIELD_CAR_LOCATION,
    FORM_FIELD_COURTESY_CAR_TYPE,
    FORM_FIELD_REIMBURSEMENT,
    FORM_FIELD_SUPPLEMENTARY_INFORMATION,
    FORM_LABEL_COURTESY_CAR_TYPE,
    FORM_LABEL_REIMBURSEMENT,
    FORM_LABEL_SUPPLEMENTARY_INFORMATION,
    FORM_CAR_REQUEST,
    FORM_CAR_REQUEST_SECTION,
    FORM_VEHICLE_DETAIL_SECTION,
    FORM_LABEL_COURTESY_NOTES_HISTORY,
    ORDER_TICKET_STATUS_NEW, ORDER_TICKET_STATUS_IN_PROGRESS_DEALER,
    FORM_LABEL_COURTESY_CAR_REQUEST,
    FORM_FIELD_COURTESY_CAR_REQUEST,
    FORM_FIELD_LOAN_EXTENSION,
    FORM_LABEL_LOAN_EXTENSION,
    ORDER_TICKET_STATUS_REOPENED,
    FORM_WAREHOUSE_SECTION,
    FORM_FIELD_UNTIL,
    FORM_LOAN_EXTENSION_SECTION,
    FORM_FIELD_AUTHORITY_GIVEN
} from '../../../../../../constants/formConstants';
import {FieldArray, formValueSelector, getFormInitialValues} from 'redux-form';
import {connect} from 'react-redux';
import CarCourtesyTableRow from './CarCourtesyTableRow';
import commonMessages from '../../../../../../intl/common/commonMessages';
import ValidFormattedMessage from '../../../../../common/ValidFormattedMessage';
import formMessages from '../../../../../../intl/sparePartsOrders/formMessages';
import courtesyCarsMessages from '../../../../../../intl/sparePartsOrders/courtesyCarsMessages';
import {courtesyCars} from '../../../../../../constants/Utils';
import get from 'get-value';
import {isEmpty} from "lodash";
import { change } from 'redux-form'
import CarCourtesyAttachment from './CarCourtesyAttachment';
import {moduleRoles} from '../../../../../../utils/roles';

const StyledDiv = styled.div`
  border-radius: 5px;
`;

const StyledHistoryDiv = styled.div`
  border-radius: 5px 5px 0 0;
  background-color: #e9ecef;
`;

class CarCourtesySection extends React.Component {
    renderContent = ({fields}) => {
        const {userRights, readOnly, form, userDetail} = this.props;
        return (
            <div>
                <StyledHistoryDiv className="border-bottom border-bottom-secondary">
                    <label className="col-form-label pl-0 font-weight-bold ml-3">
                        <ValidFormattedMessage message={FORM_LABEL_COURTESY_NOTES_HISTORY} intlMessages={formMessages}/>
                    </label>
                </StyledHistoryDiv>
                {fields.map((request, index) =>
                    <CarCourtesyTableRow key={index} index={index} request={request} userRights={userRights}
                                         readOnly={readOnly} form={form} roles={userDetail.roles}/>
                )}
            </div>
        )
    };

    handleChange = (e) => {
        change(`${FORM_FIELD_COURTESY_CAR_TYPE}`, e.value)
    }

    handleCourtesyCarRequestChange = (e, newValue) => {
        const { changeFieldValue } = this.props;
        if (newValue === 'NO' || newValue === 'UNDECIDED') {
            changeFieldValue(`${FORM_CAR_REQUEST_SECTION}.${FORM_FIELD_REIMBURSEMENT}`, '');
            changeFieldValue(`${FORM_CAR_REQUEST_SECTION}.${FORM_FIELD_COURTESY_CAR_TYPE}`, '');
            changeFieldValue(`${FORM_CAR_REQUEST_SECTION}.${FORM_FIELD_SUPPLEMENTARY_INFORMATION}`, '');
            changeFieldValue(`${FORM_CAR_REQUEST_SECTION}.${FORM_FIELD_LOAN_EXTENSION}`, '');
        }
    }

    render() {
        const {carRequests = [], repairedCarLocation, userRights, readOnly, requestCarCourtesy, reqFields, initialValues, userDetail, form, warehouseUntil, group, loanExtensionSection, authorityGiven} = this.props;
        const isDealer = moduleRoles.isDealerOrder(userDetail.roles);
        const ticketStatus = get(initialValues, 'ticketSection.status', '');
        const canDealerRequestCar = ticketStatus === ORDER_TICKET_STATUS_NEW || !authorityGiven || (warehouseUntil && authorityGiven === 'YES');
        const isDealerAndEmptyCarType = isDealer && (isEmpty(carRequests) || !isEmpty(carRequests.filter(request => !request.carType)));
        const courtesyCarRequestOptions = group === 'IT' ? ['NO', 'YES'] : ['NO', 'YES', 'UNDECIDED'];
        return (
            <>
                {(repairedCarLocation === 'OWN_WORKSHOP' || repairedCarLocation === 'SUBSIDIARY' || repairedCarLocation === 'AGENT') && ((userRights.canEditCourCarReq && !readOnly) || ((carRequests && carRequests.length > 0) || ((isDealerAndEmptyCarType || isDealer) && canDealerRequestCar))) &&
                <>
                    <h3 className="text-left mt-4 ml-4">
                        <FormattedMessage {...formMessages.WAREHOUSE_SECTION}/>
                    </h3>
                    <StyledDiv className="border border-secondary bg-white overflow-hidden">
                        {!!carRequests && carRequests.length > 0 &&
                        <FieldArray name={FORM_CAR_REQUEST} component={this.renderContent}/>
                        }
                        {!readOnly && (repairedCarLocation === 'OWN_WORKSHOP' || repairedCarLocation === 'SUBSIDIARY' || repairedCarLocation === 'AGENT') && ((userRights.canEditCourCarReq && !readOnly) || ((isDealerAndEmptyCarType || isDealer) && canDealerRequestCar)) &&
                            <div className="p-4">
                                {loanExtensionSection ?
                                    <div />
                                    :
                                    isDealer && warehouseUntil ?
                                        <div className="form-row">
                                            <div className="col-sm-12 col-xl-4">
                                                <InputSelectFieldWithValidation label={formMessages[FORM_LABEL_LOAN_EXTENSION]}
                                                                                field={FORM_FIELD_LOAN_EXTENSION}
                                                                                options={['YES', 'NO']}
                                                                                intlMessages={commonMessages}
                                                                                isDisabled={requestCarCourtesy && (requestCarCourtesy === 'NO' || requestCarCourtesy === 'UNDECIDED')}
                                                                                isRequired={reqFields.includes(FORM_FIELD_LOAN_EXTENSION)}/>
                                            </div>
                                        </div>
                                        :
                                        <>
                                            <div className="form-row">
                                                <div className="col-sm-12 col-xl-4">
                                                    <InputSelectFieldWithValidation label={formMessages[FORM_LABEL_COURTESY_CAR_REQUEST]}
                                                                                    field={FORM_FIELD_COURTESY_CAR_REQUEST}
                                                                                    options={courtesyCarRequestOptions}
                                                                                    intlMessages={commonMessages}
                                                                                    sort={false}
                                                                                    handleChange={this.handleCourtesyCarRequestChange}
                                                                                    isRequired={reqFields.includes(FORM_FIELD_COURTESY_CAR_REQUEST)}/>
                                                </div>
                                            </div>
                                            <div className="form-row align-items-end">
                                                <div className="col-sm-12 col-xl-8">
                                                    <InputSelectFieldWithValidation label={formMessages[FORM_LABEL_REIMBURSEMENT]}
                                                                                    field={FORM_FIELD_REIMBURSEMENT}
                                                                                    options={['YES', 'NO']}
                                                                                    intlMessages={commonMessages}
                                                                                    isDisabled={requestCarCourtesy && (requestCarCourtesy === 'NO' || requestCarCourtesy === 'UNDECIDED')}
                                                                                    isRequired={reqFields.includes(FORM_FIELD_REIMBURSEMENT)}/>
                                                </div>
                                                <div className="col">
                                                    <InputSelectFieldWithValidation
                                                        label={formMessages[FORM_LABEL_COURTESY_CAR_TYPE]}
                                                        field={`${FORM_FIELD_COURTESY_CAR_TYPE}`}
                                                        options={get(courtesyCars, `${get(initialValues, 'ticketSection.group', {default: 'X'})}`, {default: []})}
                                                        intlMessages={courtesyCarsMessages}
                                                        sort={false}
                                                        isRequired={(requestCarCourtesy && requestCarCourtesy === 'YES')}
                                                        useSelectInput
                                                        isSearchable
                                                        handleChange={this.handleChange}
                                                        isDisabled={requestCarCourtesy && (requestCarCourtesy === 'NO' || requestCarCourtesy === 'UNDECIDED')}
                                                        />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="col-12 pb-2">
                                                    <TextareaFieldWithValidation
                                                        label={formMessages[FORM_LABEL_SUPPLEMENTARY_INFORMATION]}
                                                        field={FORM_FIELD_SUPPLEMENTARY_INFORMATION}
                                                        rows={3}
                                                        isDisabled={requestCarCourtesy && (requestCarCourtesy === 'NO' || requestCarCourtesy === 'UNDECIDED')}/>
                                                </div>
                                            </div>
                                        </>
                                } 
                                <CarCourtesyAttachment form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
                               
                            </div>
                        }
                    </StyledDiv>
                </>
                }
            </>
        )
    }
}

const mapStateToProps = (state, initialProps) => ({
    userDetail: state.profile.userDetail,
    carRequests: formValueSelector(initialProps.form)(state, `${FORM_CAR_REQUEST_SECTION}.${FORM_CAR_REQUEST}`),
    extensionRequest: formValueSelector(initialProps.form)(state, `${FORM_CAR_REQUEST_SECTION}.${FORM_FIELD_LOAN_EXTENSION}`),
    repairedCarLocation: formValueSelector(initialProps.form)(state, `${FORM_VEHICLE_DETAIL_SECTION}.${FORM_FIELD_CAR_LOCATION}`),
    requestCarCourtesy: formValueSelector(initialProps.form)(state, `${FORM_CAR_REQUEST_SECTION}.${FORM_FIELD_COURTESY_CAR_REQUEST}`),
    warehouseUntil: formValueSelector(initialProps.form)(state, `${FORM_WAREHOUSE_SECTION}.${FORM_FIELD_UNTIL}`),
    initialValues: getFormInitialValues(initialProps.form)(state),
    group: state.profile.userDetail.group,
    loanExtensionSection: formValueSelector(initialProps.form)(state, `${FORM_LOAN_EXTENSION_SECTION}`),
    authorityGiven: formValueSelector(initialProps.form)(state, `${FORM_WAREHOUSE_SECTION}.${FORM_FIELD_AUTHORITY_GIVEN}`),
});

const mapDispatchToProps = (dispatch, props) => ({
    changeFieldValue: (field, value) => dispatch(change(props.form, field, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(CarCourtesySection);
